import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {goToPage} from '../../GenericWizardBlockSlice';
import {connect} from 'react-redux';
import attentionIcon from '../../images/attention-icon.svg';
import {buildUrlAndOpenSameWindowNew } from '../../../../../utilities/StringHelpers/StringHelpers';

const ScreenPage = (props) => {
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [error, setError] = useState('');

  if(!props.displayScreen){
    return;
  }

  useEffect(() => {
    setSelectedRadio(null);
  }, [props.displayScreen]);

  function handleRadioChange(index) {
    setError('');
    setSelectedRadio(index);
  }

  function onclickBtn(number) {
    let type = '';
    let value = '';
    if(props.displayScreen.selections?.length > 0){
        if(selectedRadio == null){
            setError('יש לבחור אחת מהאפשרויות כדי להמשיך');
            return;
        }
        const selected = props.displayScreen.selections[selectedRadio];
        if(selected?.screenIdDest){
            type = 'id';
            value = selected.screenIdDest;
        }else if(selected?.url){
            type = 'url';
            value = selected.url;
        }
    }
    else{
         type = props.displayScreen['button' + number + 'Type'];
         value = props.displayScreen['button' + number + 'Value'];
    }

    switch (type.toLowerCase()) {
      case 'id':
      case 'screeniddest':
        props.goToPage({page: 'screenPage', screenId: value});
        break;
      case 'url':
       // prepareUrl(value)
         buildUrlAndOpenSameWindowNew(value);

        break;
      case 'successpage':
        props.goToPage({page: 'successPage', screenId: ''});
        break;
      case 'errorpage':
        props.goToPage({page: 'errorPage', screenId: ''});
        break;
      default:
    }
  }

  function handleOnClickLink(item){
    if(item.isOpenSameWindow){
        let win = window.open(item.url, '_self');
        win.focus();
    }else{
        let win = window.open(item.url, '_blank');
        win.focus();
    }
  }

  return (
    <div className='screen-page'>
      {props.displayScreen.imageAboveTitle?.imageBase64 && <Image className='image-above-title' src={props.displayScreen.imageAboveTitle.imageBase64} alt={''} /> }
      {props.displayScreen.title && (
        <h1 className={`title ${props.displayScreen?.isSmallTitle ? 'small' : ''}`}>{props.displayScreen.title}</h1>
      )}
      {props.displayScreen.imageUnderTitle?.imageBase64 && <Image className='image-under-title' src={props.displayScreen.imageUnderTitle.imageBase64} alt={''} /> }
      <div className={`content-wrapper ${props.displayScreen.iframeLink ? 'full-width' : ''}`}>
        {props.displayScreen.mainText && <div className='main-text' dangerouslySetInnerHTML={{ __html: props.displayScreen.mainText }} />}
        {props.displayScreen.mainImage?.imageBase64 && <Image className='main-image' src={props.displayScreen.mainImage.imageBase64} alt={''} /> }
        {props.displayScreen.iframeLink && <iframe src={props.displayScreen.iframeLink} title="iframe" width="100%" height="650"/>}
        {props.displayScreen.selections?.length > 0 &&
        <div className='radio-btns-wrapper'>
           {props.displayScreen.selections?.map((item, i) => (
            <div className={`radio-wrapper ${selectedRadio === i ? 'checked' : ''}`} key={i}>
                <RadioInput
                name={`selection-type`}
                id={`selection-type-${i}`}
                value={item.screenIdDest || item.url}
                label={item.text}
                checked={selectedRadio === i}
                onChange={(e) => handleRadioChange(i)}
                />
            </div>
            ))}
        </div>}
        {props.displayScreen.links?.length > 0 &&
        <div className='links-wrapper'>
         {props.displayScreen.links.map((item , i) => (
             <a key={i} className='link' href={'#'} onClick={() => handleOnClickLink(item)}>{item.text}</a>
         ))}
        </div>}
        {props.displayScreen.attentionText && <div className='attention-text-wrapper'><Image src={attentionIcon} alt='attention icon' /><div className='text' dangerouslySetInnerHTML={{ __html: props.displayScreen.attentionText }} /></div> }
      </div>
      <div className={`footer ${props.displayScreen.textAboveButtons ? 'shadow' : ''}`}>
            {error && <div className='error-text'>{error}</div>}
            {props.displayScreen.textAboveButtons && <div className='buttons-title'>{props.displayScreen.textAboveButtons}</div>}
            <div className='buttons-wrapper'>
                {props.displayScreen.button1Text && (
                <BtnSubmit text={props.displayScreen.button1Text} onclick={() => onclickBtn('1')} formid={'screen-page'} />
                )}
                {props.displayScreen.button2Text && (
                <BtnSubmit text={props.displayScreen.button2Text} onclick={() => onclickBtn('2')} formid={'screen-page'} />
                )}
            </div>
        </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    displayScreen: state.genericWizardBlock.displayScreen,
  };
};

const mapDispatchToProps = {
  goToPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScreenPage);
